import { useEffect, useState } from "react";
import eventEmitter from "../events";

// returns isFixed Boolean
export function useIsFixed(fixAfter) {
    const [isFixed, setIsFixed] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > fixAfter) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [fixAfter]);

    return isFixed;
}

export function useIsSticky(element) {
    const [isSticky, setIsSticky] = useState(false);
    
    useEffect(() => {
        if (element.current) {
            let resizeObserverValue = element.current;
            var observer = new IntersectionObserver(
                ([e]) => {
                    setIsSticky(e.intersectionRatio === 0);
                },
                {
                    threshold: [0, 1],
                },
            );

            observer.observe(resizeObserverValue);

            return () => {
                observer.unobserve(resizeObserverValue);
            };
        }
    }, [element]);

    return isSticky;
}

export function useAttributesValidity() {
    const [attributeValidity, setAttributeValidity] = useState({
        isValid: false,
        hasEmptyPackageMarketingCopy: false,
    });

    useEffect(() => {
        eventEmitter.on("ATTRIBUTES_VALIDITY", updateAttributesValidity);

        return () => eventEmitter.removeListener("ATTRIBUTES_VALIDITY", updateAttributesValidity);
    }, []);

    const updateAttributesValidity = (isValid, hasEmptyPackageMarketingCopy) => {
        if (isValid !== attributeValidity.isValid || hasEmptyPackageMarketingCopy !== attributeValidity.hasEmptyPackageMarketingCopy) {
            setAttributeValidity({
                isValid,
                hasEmptyPackageMarketingCopy,
            });
        }
    };

    return attributeValidity;
}

const validityByWip = {};

export function useProductsValidity() {
    const [isProductsValid, setIsProductsValid] = useState(false);

    useEffect(() => {
        eventEmitter.on("PRODUCTS_VALIDITY", updateProductsValidity);

        return () => eventEmitter.removeListener("PRODUCTS_VALIDITY", updateProductsValidity);
    }, []);

    const updateProductsValidity = (key, isValid) => {
        validityByWip[key] = isValid;

        const isInvalid = Object.keys(validityByWip).some((w) => !validityByWip[w]);
        setIsProductsValid(!isInvalid);
    };

    return isProductsValid;
}
